import { LocationNumbersService } from '../../../services'

const getWhatsAppNumbers = async function ({ commit, dispatch, state }, locationId: string) {
  try {
    const data = await LocationNumbersService.getWhatsAppNumbers(locationId)
    return data
  } catch (error) {
    throw error
  }
}

export default getWhatsAppNumbers
